export function placementToAlign(placement: String) {
  if (!placement) return null;
  let alignment: string;

  switch (placement) {
    case "Left side":
      alignment = 'left';
      break;
    case 'Middle/Center':
      alignment = 'center';
      break;
    case 'Right side':
      alignment = 'right';
      break;
  }
  return alignment;
}
